<script setup>
    import { ref } from 'vue'
    import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { usePage } from '@inertiajs/vue3'
    const { props: propsPage } = usePage()
    const state = propsPage.state
    const statesShowDisclaimer = ['TX']
    const showDisclaimer = statesShowDisclaimer.includes(state)
    const hideDisclaimer = ref(false)

    const handleClick = () => {
        hideDisclaimer.value = !hideDisclaimer.value
    }
</script>

<template>
    <footer
        v-if="showDisclaimer"
        id="mental-health-disclaimer"
        :class="hideDisclaimer ? ' h-12 w-12 overflow-hidden rounded-lg ' : ' h-auto w-full'">
        <div id="mental-health-disclaimer-close" class="relative hidden h-4 w-full">
            <div
                class="absolute left-3 top-3 h-8 w-full cursor-pointer text-white"
                @click="handleClick">
                <font-awesome-icon
                    v-if="hideDisclaimer"
                    :icon="faChevronUp"
                    class="ada-gray-light h-6 w-6"
                    aria-hidden="true" />
                <font-awesome-icon
                    v-else
                    :icon="faChevronDown"
                    class="ada-gray-light h-6 w-6"
                    aria-hidden="true" />
            </div>
        </div>
        <div
            class="flex flex-col items-center justify-center p-4 pb-8 text-white"
            :class="hideDisclaimer ? 'hidden' : ''">
            <p class="max-w-5xl text-sm">
                U.S. SUBSTANCE ABUSE AND MENTAL HEALTH SERVICES ADMINISTRATION HELPLINE:
                <br />
                1-800-662-HELP (4357)
                <br />
                THIS HELPLINE IS A FREE, CONFIDENTIAL INFORMATION SERVICE (IN ENGLISH OR SPANISH)
                OPEN 24 HOURS PER DAY, FOR INDIVIDUALS AND FAMILY MEMBERS FACING MENTAL HEALTH OR
                SUBSTANCE USE DISORDERS. THE SERVICE PROVIDES REFERRAL TO LOCAL TREATMENT
                FACILITIES, SUPPORT GROUPS, AND COMMUNITY-BASED ORGANIZATIONS.
            </p>
        </div>
    </footer>
</template>
